import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { Page } from "../model/Page";
import { UserModel } from "../model/UserModel";
import { OrganizationRequestModel } from "../model/OrganizationRequestModel";
import { OrganizationResponseModel } from "../model/OrganizationResponseModel";
import { BoardResponseModel } from "../model/BoardResponseModel";
import { BoardRequestModel } from "../model/BoardRequestModel";
import { FeatureResponseModel } from "../model/FeatureResponseModel";
import { FeatureRequestModel } from "../model/FeatureRequestModel";
import { RoleRequestModel } from "../model/RoleRequestModel";
import { RoleResponseModel } from "../model/RoleResponseModel";
import { FeatureForRoleResponse } from "../model/FeatureForRoleResponse";
import { UserRequestModel } from "../model/UserRequestModel";
import { UserResponseModel } from "../model/UserResponseModel";
import { LotteryRequestModel } from "../model/LotteryRequestModel";
import { BoardFormResponse } from "../model/BoardFormResponse";
import { SchemeModel } from "../model/SchemeModel";
import { MatSnackBar } from "@angular/material/snack-bar";

// import { LotteryResponseModel } from '../model/LotteryResponseModel';
import { LotteryFormResponse } from "../model/LotteryFormResponse";
import { LotteryResponseModel } from "../model/LotteryResponseModel";
import { BankMasterModel } from "../model/BankMasterModel";
import { BankMasterResponseModel } from "../model/BankMasterResponseModel";
import { BankMasterRequestModel } from "../model/BankMasterRequestModel";
import { AllocateGroupFormResponse } from "../model/AllocateGroupFormResponse";
import { AllocateGroupResponseModel } from "../model/AllocateGroupResponseMode";
import { AllocateGroupLotteryListResponse } from "../model/AllocateGroupLotteryListResponse";
import { AllocateGroupRequestModel } from "../model/AllocateGroupRequestModel";
import { FileResponseModel } from "../model/FileResponseModel";
import { AnnouncementResponseModel } from "../model/AnnouncementResponseModel";
import { AnnouncementRequestModel } from "../model/AnnouncementRequestModel";
import { AnnouncementFormResponse } from "../model/AnnouncementFormResponse";
import { ApplicationsListResponseModel } from "../model/ApplicationsListResponseModel";
import { SopConfigResponse } from "../model/SopConfigResponse";
import { SopRequestModel } from "../model/SopRequestModel";
import { SopResponseModel } from "../model/SopResponseModel";
import { SopMasterModel } from "../model/SopMasterModel";
import { SopConfigResponseWrapperModel } from "../model/SopConfigResponseWrapperModel";
import { CorrigendumUploadModel } from "../model/CorrigendumUploadModel";
import { Observable } from "rxjs";
import { SopFormResponse } from "../model/SopFormResponse";
import { EmailNotificationResponseModel } from "../model/EmailNotificationResponseModel";
import { DashboardResponseModel } from "../model/DashboardResponseModel";
import { DashboardWrapperResponseModel } from "../model/DashboardWrapperResponseModel";
import { NewLotteryRequestModel } from "../model/NewLotteryRequestModel";
import { ApplicationsListResponseWrapperModel } from "../model/ApplicationsListResponseWrapperModel";
import { TenementExchangeModel } from "../model/TenementExchangeModel";
import { TenementExchangeRequestModel } from "../model/TenementExchangeRequestModel";
import { TenementExchangeOtpModel } from "../model/TenementExchangeOtpModel";
import { UploadTenementMasterModel } from "../model/UploadTenementMasterModel";
import { UploadTenementMasterListModel } from "../model/UploadTenementMasterListModel";
import { AnnouncementListModel } from "../model/AnnouncementListModel";
import { SurrReqVerificationResponse } from "../model/SurrReqVerificationResponse";
import { ProjectModel } from "../model/ProjectModel";
import { AmenityModel } from "../model/AmenityModel";
// import { ReverseWaitListResponseModel } from '../model/ReverseWaitListResponseModel';
import { InvoiceTrackingResponseModel } from "../model/InvoiceTrackingResponseModel";
import { InvoiceDetailsResponseModel } from "../model/InvoiceDetailsResponseModel";
import { InvoiceStageModel } from "../model/InvoiceStageModel";
import { InvoiceSaveModel } from "../model/InvoiceSaveModel";
import { InvoiceNoStageCountModel } from "../model/InvoiceNoStageCountModel";
import { LotteryPageWrapperResponse } from "../model/LotteryPageWrapperResponse";
import { AnnouncementPageWrapperResponse } from "../model/AnnouncementPageWrapperResponse";
import { SopManagementWrapperResponse } from "../model/SopManagementWrapperResponse";
import { SopMasterWrapperResponse } from "../model/SopMasterWrapperResponse";
import { SchemePageWrapperResponse } from "../model/SchemePageWrapperResponse";
import { UserPageWrapperResponse } from "../model/UserPageWrapperResponse";
import { FinancialYearModel } from "../model/FinancialYearModel";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  fetchRoleList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<RoleResponseModel>>(
      ApiUrls.roleList + reqParams
    );
  }

  initRoleForm() {
    return this.httpClient.get<{
      roleTypes: string[];
      features: FeatureForRoleResponse[];
    }>(`${ApiUrls.initRoleFormUrl}`);
  }

  getAllBoardForInvoice() {
    return this.httpClient.get<{
      lottery: any;
      boards: { [key: number]: string };
      status: string;
      errorMessage: string;
    }>(`${ApiUrls.initAllBoardForInvoice}`);
  }

  getSubmittedInvoiceData(page: number, size: number,stageValue: number,schemeFilter: string) {
    let params = `?page=${page}&size=${size}` +
    (stageValue ? `&stageValue=${stageValue}` : "") +
    (schemeFilter ? `&schemeFilter=${schemeFilter}` : "");
    return this.httpClient.get<Page<InvoiceDetailsResponseModel>>(
      ApiUrls.submittedInvoiceData+ params
      
    );
  }

  getInvoiceNumberDetails(page: number, size: number, invoiceNoFilter?: string, invoiceStatusFilter?: string, startDate?: string, endDate?: string) {
    let params = `?page=${page}&size=${size}` +
      (invoiceNoFilter ? `&invoiceNoFilter=${invoiceNoFilter}` : "") +
      (invoiceStatusFilter ? `&invoiceStatusFilter=${invoiceStatusFilter}` : "") +
      (startDate ? `&startDate=${startDate}` : "") +
      (endDate ? `&endDate=${endDate}` : "");
  
    return this.httpClient.get<Page<InvoiceStageModel>>(
      ApiUrls.invoiceNumberDetails + params 
    );
  }
  

  getLotteryForInvoice(key: number) {
    return this.httpClient.get<{
      lottery: { [key: number]: string };
      status: string;
      errorMessage: string;
    }>(ApiUrls.initLotteryForInvoice.replace("{key}", key.toString()));
  }

  initInvoice(
    page: number,
    size: number,
    boardKey: number,
    lotteryKey: number,
    stageValue: number,
    invoiceStatus: string
  ) {
    let reqParam =
      `?page=${page}&size=${size}` +
      `&stageValue=${stageValue}` +
      (lotteryKey ? `&lotteryKey=${lotteryKey}` : "") +
      (boardKey ? `&boardKey=${boardKey}` : "") +
      (invoiceStatus ? `&invoiceStatus=${invoiceStatus}` : "");
    return this.httpClient.get<Page<InvoiceTrackingResponseModel>>(
      ApiUrls.invoiceList + reqParam
    );
  }

  countByStages() {
    return this.httpClient.get<InvoiceStageModel>(`${ApiUrls.countOfStages}`);
  }

  countByInvoice(invoiceNo: string) {
    let reqParam = `?invoiceNo=${invoiceNo}`;
    return this.httpClient.get<InvoiceNoStageCountModel>(
      ApiUrls.countByInvoice + reqParam
    );
  }

  sendInvoiceNumber(invoiceNo: string, invoiceDate: string) {
    let reqParam = `?invoiceNo=${invoiceNo}` +
    `&invoiceDate=${invoiceDate}`;
    return this.httpClient.get<{ status: string; errorMessage: string }>(
      ApiUrls.setInvoiceNumber + reqParam
    );
  }

  fetchInvoiceDetailView(page: number, size: number, invoiceNo: String) {
    let reqParams = `?page=${page}&size=${size}&invoiceNo=${invoiceNo}`;
    return this.httpClient.get<Page<InvoiceStageModel>>(
      ApiUrls.fetchInvoiceDetails+
        reqParams
    );
  }

  fetchInvoiceReceipt(invoiceNo: string,invoiceDate: string) {
    let reqParam = `?invoiceNo=${invoiceNo}` +
    `&invoiceDate=${invoiceDate}`;
    return this.httpClient.get<InvoiceStageModel>(
      ApiUrls.fetchInvoiceReceipt + reqParam
    );
  }

  saveSettledInvoice(approve: InvoiceSaveModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveSettledInvoice}`,
      approve
    );
  }

  saveInvoiceDetails(invoicedetails: InvoiceDetailsResponseModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveInvoiceDetails}`,
      invoicedetails
    );
  }

  deleteInvoiceRecord(key: number) {
    //return this.httpClient.delete<>
    return this.httpClient.delete<{ status: string; errorMessage: string }>(
      ApiUrls.deleteInvoiceRecord.replace("{key}", key?.toString())
    );
  }

  cancelInvoice(invoiceNo: string, invoiceStatus: string) {
    //return this.httpClient.delete<>
    let reqParams = `?invoiceNo=${invoiceNo}&invoiceStatus=${invoiceStatus}`;
    return this.httpClient.delete<{ status: string; errorMessage: string }>(
      ApiUrls.cancelInvoice + reqParams
    );
  }

  downloadInvoiceReceipt(invoiceNo: string) {
    //return this.httpClient.delete<>
    let reqParams = `?invoiceNo=${invoiceNo}`;
    return this.httpClient.get<{ status: string;  data: string; errorMessage: string }>(
      ApiUrls.downloadInvoiceReceipt + reqParams
    );
  }

  saveRole(role: RoleRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveRole}`,
      role
    );
  }

  getRoleBykey(roleKey: number) {
    return this.httpClient.get<RoleResponseModel>(
      ApiUrls.getRoleByKeyUrl.replace("{roleKey}", roleKey.toString())
    );
  }

  updateRole(roleKey: number, role: RoleRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateRoleUrl.replace("{roleKey}", roleKey.toString())}`,
      role
    );
  }

  toggleActivationRole(roleKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationRoleUrl.replace("{roleKey}", roleKey.toString()),
      {
        activeFlag,
      }
    );
  }

  toggleActivationProject(projectKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationProjectUrl.replace(
        "{projectKey}",
        projectKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  toggleActivationAmenity(amenityKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationAmenityUrl.replace(
        "{amenityKey}",
        amenityKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  toggleActivationFinancialYear(financialYearKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationFinancialYearUrl.replace(
        "{financialYearKey}",
        financialYearKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  fetchUserList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<UserPageWrapperResponse>(
      ApiUrls.userList + reqParams
    );
  }

  fetchLotteryList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<LotteryResponseModel>>(
      ApiUrls.lotteryList + reqParams
    );
  }

  fetchNewLotteryList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<LotteryPageWrapperResponse>(
      ApiUrls.newLotteryList + reqParams
    );
  }

  fetchDashboardApplicationList(
    page: number,
    size: number,
    filterText?: string,
    nocFilter?: string,
    schemeFilter?: string,
    accepenceStatusFilter?: string,
    polFilter?: string,
    allotmentFilter?: string,
    insPaymentFilter?: string,
    appDrawStatus?: string,
    incomeFilter?: string,
    categoryFilter?: string,
    possessionFilter?: string,
    draftAllotmentFilter?: string,
    firstInstStatus?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "") +
      (nocFilter ? `&nocFilter=${nocFilter}` : "") +
      (schemeFilter ? `&schemeFilter=${schemeFilter}` : "") +
      (incomeFilter ? `&incomeFilter=${incomeFilter}` : "") +
      (categoryFilter ? `&categoryFilter=${categoryFilter}` : "") +
      (accepenceStatusFilter
        ? `&accepenceStatusFilter=${accepenceStatusFilter}`
        : "") +
      (polFilter ? `&polFilter=${polFilter}` : "") +
      (allotmentFilter ? `&allotmentFilter=${allotmentFilter}` : "") +
      (draftAllotmentFilter
        ? `&draftAllotmentFilter=${draftAllotmentFilter}`
        : "") +
      (appDrawStatus ? `&appDrawStatus=${appDrawStatus}` : "") +
      (insPaymentFilter ? `&insPaymentFilter=${insPaymentFilter}` : "") +
      (possessionFilter ? `&possessionFilter=${possessionFilter}` : "") +
      (firstInstStatus ? `&firstInstStatus=${firstInstStatus}` : "");
    return this.httpClient.get<DashboardWrapperResponseModel>(
      ApiUrls.dashBoardApplicationList + reqParams
    );
  }

  fetchMISReport(
    filterText?: string,
    nocFilter?: string,
    schemeFilter?: string,
    accepenceStatusFilter?: string,
    polFilter?: string,
    allotmentFilter?: string,
    insPaymentFilter?: string,
    appDrawStatus?: string,
    incomeFilter?: string,
    categoryFilter?: string,
    possessionFilter?: string,
    draftAllotmentFilter?: string,
    firstInstStatus?: string
  ) {
    let reqParams =
      `?lotteryId=1` +
      (filterText ? `&filterText=${filterText}` : "") +
      (nocFilter ? `&nocFilter=${nocFilter}` : "") +
      (schemeFilter ? `&schemeFilter=${schemeFilter}` : "") +
      (incomeFilter ? `&incomeFilter=${incomeFilter}` : "") +
      (categoryFilter ? `&categoryFilter=${categoryFilter}` : "") +
      (accepenceStatusFilter
        ? `&accepenceStatusFilter=${accepenceStatusFilter}`
        : "") +
      (polFilter ? `&polFilter=${polFilter}` : "") +
      (allotmentFilter ? `&allotmentFilter=${allotmentFilter}` : "") +
      (draftAllotmentFilter
        ? `&draftAllotmentFilter=${draftAllotmentFilter}`
        : "") +
      (appDrawStatus ? `&appDrawStatus=${appDrawStatus}` : "") +
      (insPaymentFilter ? `&insPaymentFilter=${insPaymentFilter}` : "") +
      (possessionFilter ? `&possessionFilter=${possessionFilter}` : "") +
      (firstInstStatus ? `&firstInstStatus=${firstInstStatus}` : "");
    return this.httpClient.get<{
      lst: { [key: string]: string }[];
      title: string;
      columnNames: string[];
      columnWidths: string;
      status: string;
      errorMessage: string;
      generatedBy: string;
      generatedOn: string;
    }>(ApiUrls.fetchMIS + reqParams);
  }

  fetchReport() // filterText?: string,
  // nocFilter?: string,
  // schemeFilter?: string,
  // accepenceStatusFilter?: string,
  // polFilter?: string,
  // allotmentFilter?: string,
  // insPaymentFilter?: string,
  // appDrawStatus?: string,
  // incomeFilter?: string,
  // categoryFilter?: string,
  // possessionFilter?: string,
  // draftAllotmentFilter?: string,
  // firstInstStatus?: string
  {
    // let reqParams =
    // `?lotteryId=1` +
    // (filterText ? `&filterText=${filterText}` : "") +
    // (nocFilter ? `&nocFilter=${nocFilter}` : "") +
    // (schemeFilter ? `&schemeFilter=${schemeFilter}` : "") +
    // (incomeFilter ? `&incomeFilter=${incomeFilter}` : "") +
    // (categoryFilter ? `&categoryFilter=${categoryFilter}` : "") +
    // (accepenceStatusFilter
    //   ? `&accepenceStatusFilter=${accepenceStatusFilter}`
    //   : "") +
    // (polFilter ? `&polFilter=${polFilter}` : "") +
    // (allotmentFilter ? `&allotmentFilter=${allotmentFilter}` : "") +
    // (draftAllotmentFilter
    //   ? `&draftAllotmentFilter=${draftAllotmentFilter}`
    //   : "") +
    // (appDrawStatus ? `&appDrawStatus=${appDrawStatus}` : "") +
    // (insPaymentFilter ? `&insPaymentFilter=${insPaymentFilter}` : "") +
    // (possessionFilter ? `&possessionFilter=${possessionFilter}` : "") +
    // (firstInstStatus ? `&firstInstStatus=${firstInstStatus}` : "");
    return this.httpClient.get<{
      lst: { [key: string]: string }[];
      title: string;
      columnNames: string[];
      columnWidths: string;
      status: string;
      errorMessage: string;
      generatedBy: string;
      generatedOn: string;
    }>(ApiUrls.fetchReport);
  }

  fetchSopMasterList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<SopMasterWrapperResponse>(
      ApiUrls.getSopMaster + reqParams
    );
  }

  fetchSopLotteryList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<SopManagementWrapperResponse>(
      ApiUrls.sopLotteryList + reqParams
    );
  }

  fetchBankMasterList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<BankMasterModel>>(
      ApiUrls.bankMasterList + reqParams
    );
  }

  fetchSchemeList(page: number, size: number, filterText: any) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<SchemePageWrapperResponse>(
      ApiUrls.schemeList + reqParams
    );
  }

  fetchProjectList(page: number, size: number, filterText: any) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<ProjectModel>>(
      ApiUrls.projectList + reqParams
    );
  }

  fetchAmenityList(page: number, size: number, filterText: any) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<AmenityModel>>(
      ApiUrls.amenityList + reqParams
    );
  }

  fetchFinancialYearList(page: number, size: number, filterText: any) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<FinancialYearModel>>(
      ApiUrls.financialYearList + reqParams
    );
  }

  initUserForm() {
    return this.httpClient.get<{
      roles: { [key: number]: string };
      boards: { [key: number]: string };
      boardWiseDepartments: { [key: number]: { [key: number]: string } };
      departmentWiseDesignations: { [key: number]: { [key: number]: string } };
    }>(`${ApiUrls.initUserFormUrl}`);
  }

  initSchemeForm() {
    return this.httpClient.get<{
      lotteryList: { [key: number]: string };
      mpIncomeGroupListLotteryWise: {
        [key: number]: { [key: number]: string };
      };
      amenityList: {
        amenitySystemConfigKey: number;
        amenityConfigKey: string;
        amenityConfigValue: string;
        amenityConfigImage: string;
      };
    }>(`${ApiUrls.initSchemeFormUrl}`);
  }

  initProjectForm() {
    return this.httpClient.get<{
      boardList: { [key: number]: string };
      amenityList: {
        amenitySystemConfigKey: number;
        amenityConfigKey: string;
        amenityConfigValue: string;
        amenityConfigImage: string;
      };
    }>(`${ApiUrls.initProjectFormUrl}`);
  }

  saveUser(user: UserRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveUser}`,
      user
    );
  }

  saveSopMaster(sopMaster: SopMasterModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveSopMaster}`,
      sopMaster
    );
  }

  saveSop(sopRequestModel: SopRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveSopConfig}`,
      sopRequestModel
    );
  }

  updatePassword(password: string) {
    console.log("Inner Method", password);

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.updatePassword}`,
      {
        password,
      }
    );
  }

  saveBankMaster(bankMaster: BankMasterRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveBankMaster}`,
      bankMaster
    );
  }

  saveScheme(obj: {}) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveScheme}`,
      obj
    );
  }

  saveProject(obj: {}) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveProject}`,
      obj
    );
  }

  saveAmenity(obj: {}) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveAmenity}`,
      obj
    );
  }

  saveFinancialYear(obj: {}) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveFinancialYear}`,
      obj
    );
  }

  async showSchemeImages(type: string, fileName: string) {
    console.log(`${ApiUrls.schemeImagesUrl}/${type}/${fileName}`);
    this.httpClient
      .get(`${ApiUrls.schemeImagesUrl}/${type}/${fileName}`)
      .subscribe((data) => {
        return data;
      });
  }

  getUserBykey(userKey: number) {
    return this.httpClient.get<UserResponseModel>(
      ApiUrls.getUserByKeyUrl.replace("{userKey}", userKey.toString())
    );
  }

  getBankMasterBykey(bankKey: number) {
    return this.httpClient.get<BankMasterResponseModel>(
      ApiUrls.getBankMasterByKeyUrl.replace("{bankKey}", bankKey.toString())
    );
  }

  getSchemeBykey(schemeKey: number) {
    return this.httpClient.get<SchemeModel>(
      ApiUrls.getSchemeByKeyUrl.replace("{schemeKey}", schemeKey.toString())
    );
  }

  getProjectBykey(projectKey: number) {
    return this.httpClient.get<ProjectModel>(
      ApiUrls.getProjectByKeyUrl.replace("{projectKey}", projectKey.toString())
    );
  }

  getAmenityBykey(amenityKey: number) {
    return this.httpClient.get<ProjectModel>(
      ApiUrls.getAmenityByKeyUrl.replace("{amenityKey}", amenityKey.toString())
    );
  }

  getFinancialYearBykey(financialKey: number) {
    return this.httpClient.get<ProjectModel>(
      ApiUrls.getFinancialYearByKeyUrl.replace("{financialYearKey}", financialKey.toString())
    );
  }

  updateUser(userKey: number, user: UserRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateUserUrl.replace("{userKey}", userKey.toString())}`,
      user
    );
  }

  updateSopMaster(key: number, sopMaster: SopMasterModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateSopMasterUrl.replace("{key}", key.toString())}`,
      sopMaster
    );
  }

  updateBankMaster(bankKey: number, bankMaster: BankMasterRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateBankMasterUrl.replace("{bankKey}", bankKey.toString())}`,
      bankMaster
    );
  }

  updateScheme(schemeKey: number, obj: {}) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateSchemeUrl.replace("{schemeKey}", schemeKey.toString())}`,
      obj
    );
  }

  updateProject(projectKey: number, obj: {}) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateProjectUrl.replace(
        "{projectKey}",
        projectKey.toString()
      )}`,
      obj
    );
  }

  updateAmenity(amenityKey: number, obj: {}) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateAmenityUrl.replace(
        "{amenityKey}",
        amenityKey.toString()
      )}`,
      obj
    );
  }

  updateFinancialYear(financialYearKey: number, obj: {}) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateFinancialYearUrl.replace(
        "{financialYearKey}",
        financialYearKey.toString()
      )}`,
      obj
    );
  }

  toggleActivationUser(userKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationUserUrl.replace("{userKey}", userKey.toString()),
      {
        activeFlag,
      }
    );
  }

  deactiveSop(key: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.deleteSop.replace("{key}", key.toString()),
      {
        key,
        activeFlag,
      }
    );
  }

  deactiveSopSteps(key: number) {
    console.log(ApiUrls.deactiveSopSteps.replace("{key}", key.toString()));
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.deactiveSopSteps.replace("{key}", key.toString()),
      {}
    );
  }

  deactiveSopSubSteps(key: number) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.deactiveSopSubSteps.replace("{key}", key.toString()),
      {}
    );
  }

  deleteBankMaster(bankKey: number) {
    return this.httpClient.delete<{ status: string; errorMessage: string }>(
      ApiUrls.deleteBankMasterUrl.replace("{bankKey}", bankKey.toString())
    );
  }

  resetUserPassword(userKey: number) {
    return this.httpClient.get<{ status: string; errorMessage: string }>(
      ApiUrls.resetUserPasswordUrl.replace("{userKey}", userKey.toString())
    );
  }

  changeDefaultPassword(password: string) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateDefaultPasswordUrl}`,
      {
        password: password,
      }
    );
  }

  addcorigendumFile(
    key: number,
    registrationId: number,
    corrigendumName: string,
    corrigendumFileName: string
  ) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.addCorrigendum}`,
      {
        key: key,
        registrationId: registrationId,
        corrigendumName: corrigendumName,
        corrigendumFileName: corrigendumFileName,
      }
    );
  }

  getCorrigendumDetails(registrationId: number) {
    let reqParams = `?registrationId=${registrationId}`;
    return this.httpClient.get<CorrigendumUploadModel[]>(
      ApiUrls.getCorrigendumDetails + reqParams
    );
  }

  initCorrigendumDetails(key: number) {
    return this.httpClient.get<CorrigendumUploadModel>(
      ApiUrls.initCorrigendumDetails.replace("{key}", key.toString())
    );
  }

  deactiveCorrigendum(key: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.deactivateCorrigendum.replace("{key}", key.toString()),
      {
        key,
        activeFlag,
      }
    );
  }

  downloadFile(registrationId: number, documentPath: any) {
    return this.httpClient.get<{
      status: string;
      data: string;
      errorMessage: string;
    }>(
      ApiUrls.viewPdf
        .replace("{registrationId}", registrationId.toString())
        .replace("{document}", documentPath)
    );
  }

  downloadCorrigendum(key: number) {
    return this.httpClient.get<CorrigendumUploadModel>(
      ApiUrls.downloadCorrigendum.replace("{key}", key.toString())
    );
  }

  // deActivateUser(key: number) {
  //   return this.httpClient.patch<{status: string, errorMessage: string}>(ApiUrls.userList + reqParams);
  // }

  getOrgList() {
    console.log("this is comming from organisation service");
    return this.httpClient.get<Page<OrganizationResponseModel>>(
      `${ApiUrls.organizationList}`
    );
  }

  saveOrg(organization: OrganizationRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveOrg}`,
      organization
    );
  }

  getOrgBykey(orgkey: number) {
    return this.httpClient.get<OrganizationResponseModel>(
      ApiUrls.getOrgByKeyUrl.replace("{organizationKey}", orgkey.toString())
    );
  }

  updateOrg(organizationKey: number, organization: OrganizationRequestModel) {
    console.log(
      "this is comming from organization service***** Update call **** ",
      organization
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateOrgUrl.replace(
        "{organizationKey}",
        organizationKey.toString()
      )}`,
      organization
    );
  }

  deactivareOrg(organizationKey: number, activeFlag: string) {
    console.log(
      "this is comming from organization service***** Deactivate call **** " +
        organizationKey +
        "  flag " +
        activeFlag
    );
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.activeDactiveOrgUrl.replace(
        "{organizationKey}",
        organizationKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  getFeatureList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<FeatureResponseModel>>(
      `${ApiUrls.featureList}` + reqParams
    );
  }

  initFeatureForm() {
    return this.httpClient.get<{
      parentFeatureList: { [key: number]: string };
    }>(`${ApiUrls.initFeatureFormUrl}`);
  }

  getFileList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<EmailNotificationResponseModel>>(
      `${ApiUrls.fileList}` + reqParams
    );
  }
  getPaymentRefundUploadFileList(
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<EmailNotificationResponseModel>>(
      `${ApiUrls.getPaymentRefundUploadFileList}` + reqParams
    );
  }
  //  initFileForm() {
  //    return this.httpClient.get<{
  //      fileNames: { [key: number]: string };
  //    }>(`${ApiUrls.initFileFormUrl}`);
  //  }

  saveFeature(feature: FeatureRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveFeature}`,
      feature
    );
  }

  getFeatureBykey(featureKey: number) {
    return this.httpClient.get<FeatureResponseModel>(
      ApiUrls.getFeatureByKeyUrl.replace("{featureKey}", featureKey.toString())
    );
  }

  updateFeature(featureKey: number, feature: FeatureRequestModel) {
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateFeatureUrl.replace(
        "{featureKey}",
        featureKey.toString()
      )}`,
      feature
    );
  }

  toggleActivationFeature(featureKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationFeatureUrl.replace(
        "{featureKey}",
        featureKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  getBoardList() {
    console.log("this is comming from Master service Get board list");
    return this.httpClient.get<Page<BoardResponseModel>>(
      `${ApiUrls.boardList}`
    );
  }

  saveBoard(board: BoardRequestModel) {
    console.log("this is comming from Master service save board");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveBoard}`,
      board
    );
  }

  initBoardForm() {
    return this.httpClient.get<BoardFormResponse>(ApiUrls.initBoardForm);
  }

  getBoardBykey(boardkey: number) {
    console.log(
      "this is comming from Master service Get board by key " + boardkey
    );
    return this.httpClient.get<BoardResponseModel>(
      ApiUrls.getBoardByKeyUrl.replace("{boardKey}", boardkey.toString())
    );
  }

  updateBoard(boardkey: number, board: BoardRequestModel) {
    console.log(
      "this is comming from master service for ***** Update Board call **** ",
      board
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateBoardUrl.replace("{boardKey}", boardkey.toString())}`,
      board
    );
  }

  deactivateBoard(boardkey: number, activeFlag: string) {
    console.log(
      "this is comming from master service***** Deactivate call **** " +
        boardkey +
        "  flag " +
        activeFlag
    );
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.activeDactiveBoardUrl.replace("{boardKey}", boardkey.toString()),
      {
        activeFlag,
      }
    );
  }

  getLotteryList() {
    console.log("this is comming from Master service Get board list");
    return this.httpClient.get<Page<LotteryResponseModel>>(
      `${ApiUrls.lotteryList}`
    );
  }

  getAllLotteryList() {
    return this.httpClient.get<LotteryFormResponse>(
      `${ApiUrls.allLotteryList}`
    );
  }

  saveLottery(lottery: LotteryRequestModel) {
    console.log("this is comming from Master service save Lottery");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveLottery}`,
      lottery
    );
  }

  saveNewLottery(lottery: NewLotteryRequestModel) {
    console.log("this is comming from Master service save Lottery");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveNewLottery}`,
      lottery
    );
  }

  initLotteryForm(lotteryKey: number) {
    let lotteryKeyParam = lotteryKey ? `?lotteryKey=${lotteryKey}` : "";
    return this.httpClient.get<LotteryFormResponse>(
      ApiUrls.initLotteryForm + lotteryKeyParam
    );
  }

  initNewLotteryForm(lotteryKey: number) {
    let lotteryKeyParam = lotteryKey ? `?lotteryKey=${lotteryKey}` : "";
    return this.httpClient.get<LotteryFormResponse>(
      ApiUrls.initNewLotteryForm + lotteryKeyParam
    );
  }

  initSopMasterForm(key: number) {
    return this.httpClient.get<SopConfigResponseWrapperModel>(
      ApiUrls.initSopMasterForm.replace("{key}", key.toString())
    );
  }

  getLotteryBykey(lotterykey: number) {
    console.log(
      "this is comming from Master service Get Lottery by key " + lotterykey
    );
    return this.httpClient.get<LotteryResponseModel>(
      ApiUrls.getLotteryByKeyUrl.replace("{lotteryKey}", lotterykey.toString())
    );
  }

  updateLottery(lotteryKey: number, lottery: LotteryRequestModel) {
    console.log(
      "this is comming from master service for ***** Update Lottery call **** ",
      lottery
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updatelotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )}`,
      lottery
    );
  }

  updateNewLottery(lotteryKey: number, lottery: NewLotteryRequestModel) {
    console.log(
      "this is comming from master service for ***** Update Lottery call **** ",
      lottery
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateNewlotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )}`,
      lottery
    );
  }

  deactivateLottery(lotteryKey: number, activeFlag: string) {
    console.log(
      "this is comming from master service***** Deactivate call **** " +
        lotteryKey +
        "  flag " +
        activeFlag
    );
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.activeDactiveLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  deactivateNewLottery(lotteryKey: number, activeFlag: string) {
    console.log(
      "this is comming from master service***** Deactivate call **** " +
        lotteryKey +
        "  flag " +
        activeFlag
    );
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.activeDactiveNewLotteryUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  initAllocateGroupForm() {
    return this.httpClient.get<AllocateGroupFormResponse>(
      ApiUrls.initallocateGroupForm
    );
  }

  getLotteryCategoryListBykey(lotterykey: number) {
    console.log(
      "this is comming from Master service Get Lottery category List by key " +
        lotterykey
    );
    return this.httpClient.get<AllocateGroupLotteryListResponse>(
      ApiUrls.getLotteryCategoryListByKeyUrl.replace(
        "{lotteryKey}",
        lotterykey.toString()
      )
    );
  }

  saveAllocateGroup(allocateGroup: AllocateGroupRequestModel) {
    console.log("this is comming from Master service save Allocate Group");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveAllocateGroup}`,
      allocateGroup
    );
  }

  genereteDraftList(boardKey: number, lotteryKey: number) {
    console.log(
      "generete Draft List Call **** " + lotteryKey + "  BoardKey " + boardKey
    );
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.genereteDraftListUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }

  generateHashcodeReport(lotteryKey: number) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateHashcodeReportUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }

  //For Announcement
  // fetchAnnouncementList(page: number, size: number, filterText?: string) {
  //   console.log("in master service get call");
  //   let reqParams =
  //     `?page=${page}&size=${size}` +
  //     (filterText ? `&filterText=${filterText}` : "");
  //   return this.httpClient.get<Page<AnnouncementResponseModel>>(
  //     ApiUrls.announcementList + reqParams
  //   );
  // }

  fetchAnnouncementList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");

    console.log("in master service get call");
    return this.httpClient.get<AnnouncementPageWrapperResponse>(
      ApiUrls.announcementList + reqParams
    );
  }

  toggleActivationAnnouncement(announcementKey: number, activeFlag: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.toggleActivationAnnouncementUrl.replace(
        "{announcementKey}",
        announcementKey.toString()
      ),
      {
        activeFlag,
      }
    );
  }

  initAnnouncementForm(announcementKey: number) {
    let announcementKeyParam = announcementKey
      ? `?announcementKey=${announcementKey}`
      : "";
    return this.httpClient.get<AnnouncementFormResponse>(
      ApiUrls.initAnnouncementForm + announcementKeyParam
    );
  }

  saveAnnouncement(announcement: AnnouncementRequestModel) {
    console.log("this is comming from Master service save Announcement");
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveAnnouncement}`,
      announcement
    );
  }

  getAnnouncementBykey(announcementKey: number) {
    console.log(
      "this is comming from Master service Get Lottery by key " +
        announcementKey
    );
    return this.httpClient.get<AnnouncementListModel>(
      ApiUrls.getAnnouncementByKeyUrl.replace(
        "{announcementKey}",
        announcementKey.toString()
      )
    );
  }

  updateAnnouncement(
    announcementKey: number,
    announcement: AnnouncementRequestModel
  ) {
    console.log(
      "this is comming from master service for ***** Update Lottery call **** ",
      announcement
    );
    return this.httpClient.put<{ status: string; errorMessage: string }>(
      `${ApiUrls.updateAnnouncementUrl.replace(
        "{announcementKey}",
        announcementKey.toString()
      )}`,
      announcement
    );
  }

  //for Application list for document verification
  fetchApplicantList(
    page: number,
    size: number,
    filterText?: string,
    wtlType?: string
  ) {
    console.log("in master service get ApplicationsList call");
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "") +
      (wtlType ? `&wtlType=${wtlType}` : "");
    return this.httpClient.get<Page<ApplicationsListResponseModel>>(
      ApiUrls.applicatntsList + reqParams
    );
  }

  //for Application list for fetching waitlist application
  fetchApplicantsList(
    page: number,
    size: number,
    filterText?: string,
    wtlType?: string,
    selectedLotteryCode?: string,
    selectedSchemeCode?: string,
    selectedCategoryCode?: string
  ) {
    console.log("in master service get ApplicationsList call");
    let reqParams =
      `?page=${page}&size=${size}` +
      `&wtlType=${wtlType}` +
      (filterText ? `&filterText=${filterText}` : "") +
      (selectedLotteryCode && selectedLotteryCode != "Select Lottery Code"
        ? `&selectedLotteryCode=${selectedLotteryCode}`
        : "") +
      (selectedSchemeCode && selectedSchemeCode != "Select Scheme Code"
        ? `&selectedSchemeCode=${selectedSchemeCode}`
        : "") +
      (selectedCategoryCode && selectedCategoryCode != "Select Category"
        ? `&selectedCategoryCode=${selectedCategoryCode}`
        : "");
    return this.httpClient.get<ApplicationsListResponseWrapperModel>(
      ApiUrls.applicatntsList + reqParams
    );
  }

  //to get WaitList Types
  // fetchWaitlistType() {
  //   return this.httpClient.get<LotteryFormResponse>(ApiUrls.getWaitListTypes);
  // }

  // for Activate WaitList
  toggleActivateWaitList(applicationKey: number, wtlType: string) {
    return this.httpClient.patch<{
      status: string;
      errorMessage: string;
      successMsg: string;
    }>(
      ApiUrls.toggleActivateWaitList
        .replace("{applicationKey}", applicationKey.toString())
        .replace("{wtlType}", wtlType),
      {}
    );
  }

  toggleActivateAllWaitList(
    wtlType: string,
    selectedLotteryCodeFilter?: string,
    selectedSchemeCodeFilter?: string,
    selectedCategoryCodeFilter?: string
  ) {
    let selectedLotteryCode =
      selectedLotteryCodeFilter &&
      selectedLotteryCodeFilter != "Select Lottery Code"
        ? selectedLotteryCodeFilter
        : null;
    let selectedSchemeCode =
      selectedSchemeCodeFilter &&
      selectedSchemeCodeFilter != "Select Scheme Code"
        ? selectedSchemeCodeFilter
        : null;
    let selectedCategoryCode =
      selectedCategoryCodeFilter &&
      selectedCategoryCodeFilter != "Select Category"
        ? selectedCategoryCodeFilter
        : null;

    let reqParams = `?wtlType=${wtlType}`;

    reqParams += `&selectedLotteryCode=${selectedLotteryCode}`;

    if (selectedSchemeCode) {
      reqParams += `&selectedSchemeCode=${selectedSchemeCode}`;
    }

    if (selectedCategoryCode) {
      reqParams += `&selectedCategoryCode=${selectedCategoryCode}`;
    }
    return this.httpClient.post<{
      status: string;
      errorMessage: string;
      successMsg: string;
    }>(ApiUrls.toggleActivateAllWaitList + reqParams, {});
  }

  //for Reverse Activated Tenement
  // fetchApplicantListForReverse(page: number, size: number, filterText?: string) {
  //   console.log("in master service get ApplicationsList call");
  //   let reqParams = `?page=${page}&size=${size}` + (filterText ? `&filterText=${filterText}` : '');
  //   return this.httpClient.get<Page<ReverseWaitListResponseModel>>(ApiUrls.applicatntsListForReverse + reqParams);
  // }

  // toggleReverseWaitList(applicationKey: number) {
  //   return this.httpClient.post<{status: string, errorMessage: string, successMsg : string}
  //   >(ApiUrls.toggleReverseWaitList.replace('{applicationKey}', applicationKey.toString()), {

  //   });
  // }

  // fetchSopConfig(type: string, lotteryId: number) {
  //   return this.httpClient.get<SopConfigResponse[]>(
  //     ApiUrls.fetchSopConfiguration
  //       .replace(`{type}`, type.toString())
  //       .replace(`{lotteryId}`, lotteryId.toString())
  //   );
  // }

  // fetchSopConfig(type : string, lotteryId :number) {
  //   return this.httpClient.get<SopConfigResponse[]>(
  //       ApiUrls.fetchSopConfiguration.
  //       replace(`{type}`, type.toString())
  //       .replace(`{lotteryId}`, lotteryId.toString()));
  // }

  fetchSopConfig(key: number, lotteryId: number) {
    return this.httpClient.get<SopConfigResponseWrapperModel>(
      ApiUrls.fetchSopConfiguration
        .replace(`{key}`, key.toString())
        .replace(`{lotteryId}`, lotteryId.toString())
    );
  }

  generateBulkLoi(lotteryKey: number) {
    console.log("generete bulk loi **** " + lotteryKey);
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateBulkLoiUrl.replace("{lotteryKey}", lotteryKey.toString())
    );
  }

  generateBulkPushToModerationJob() {
    console.log("bulk Push To Moderation Job **** ");
    return this.httpClient.post<{
      status: string;
      errorMessage: string;
      successMsg: string;
    }>(ApiUrls.bulkPushToModerationJob, {});
  }

  generateDomicileModerationJob() {
    return this.httpClient.get<{
      status: string;
      errorMessage: string;
      successMsg: string;
    }>(ApiUrls.generateDomileModeration);
  }
  generateSettlementPaymentJob() {
    return this.httpClient.get<{
      status: string;
      errorMessage: string;
      successMsg: string;
    }>(ApiUrls.generateSettlementPayment);
  }
  generateBulkPOL(lotteryKey: number) {
    console.log("generete bulk POL **** " + lotteryKey);
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateBulkPOLUrl.replace("{lotteryKey}", lotteryKey.toString())
    );
  }

  downloadSop(key: any) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.downloadSopUrl.replace("{key}", key)
    );
  }
  downloadSopTemplate(key: string) {
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.downloadSopTemplateUrl.replace("{key}", key)
    );
  }

  exportMIS() {
    return this.httpClient.get<FileResponseModel>(ApiUrls.exportMIS);
  }

  refreshDashboard() {
    console.log("ApiUrls.refreshDashboard = ", ApiUrls.refreshDashboard);
    return this.httpClient.get<{ status: string; errorMessage: string }>(
      ApiUrls.refreshDashboard
    );
  }

  generateDrawResult(boardKey: number, lotteryKey: number) {
    console.log(
      "generete Lottery Draw Result Call **** " +
        lotteryKey +
        "  BoardKey " +
        boardKey
    );
    return this.httpClient.get<FileResponseModel>(
      ApiUrls.generateDrawResultUrl.replace(
        "{lotteryKey}",
        lotteryKey.toString()
      )
    );
  }
  // downloadEmailSmsTemplate() {
  //   return this.httpClient.get<{status: string, errorMessage: string, data: string | ArrayBuffer}>(
  //     ApiUrls.downloadEmailSmsTemplateUrl
  //     );
  // }
  downloadPaymentRefundTemplate() {
    return this.httpClient.get<{
      status: string;
      errorMessage: string;
      data: string | ArrayBuffer;
    }>(ApiUrls.downloadPaymentRefundTemplateUrl);
  }

  bulkEmailSmsResults(
    subject: string,
    emailSmsBody: string,
    notification: string,
    email: String,
    sms: String,
    base64: string | ArrayBuffer,
    fileName: string
  ) {
    return this.httpClient.post<{
      status: string;
      errorMessage: string;
      sucessMessage: string;
    }>(ApiUrls.bulkEmailSmsUrl, {
      subject: subject,
      emailSmsBody: emailSmsBody,
      notification: notification,
      email: email,
      sms: sms,
      bas64Data: base64,
      fileName: fileName,
    });
  }
  finalBulkEmailSmsResults(
    subject: string,
    emailSmsBody: string,
    notification: string,
    email: String,
    sms: String,
    base64: string | ArrayBuffer,
    fileName: string
  ) {
    return this.httpClient.post<{
      status: string;
      errorMessage: string;
      sucessMessage: string;
    }>(ApiUrls.finalBulkEmailSmsUrl, {
      subject: subject,
      emailSmsBody: emailSmsBody,
      notification: notification,
      email: email,
      sms: sms,
      bas64Data: base64,
      fileName: fileName,
    });
  }

  finalBulkPaymentRefundResults(
    base64: string | ArrayBuffer,
    fileName: string
  ) {
    return this.httpClient.post<{
      status: string;
      errorMessage: string;
      sucessMessage: string;
    }>(ApiUrls.finalBulkPaymentRefundResults, {
      bas64Data: base64,
      fileName: fileName,
    });
  }
  downloadEmailNotification(key: number) {
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadEmailNotificationUrl.replace("{key}", key.toString()),
      null
    );
  }

  downloadUploadFile(key: number) {
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadUploadFileUrl.replace("{key}", key.toString()),
      null
    );
  }
  downloadPaymentRefundUploadFile(key: number) {
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadPaymentRefundUploadFileUrl.replace(
        "{key}",
        key.toString()
      ),
      null
    );
  }
  downloadPaymentRefundFile(key: number) {
    return this.httpClient.post<FileResponseModel>(
      ApiUrls.downloadPaymentRefundUrl.replace("{key}", key.toString()),
      null
    );
  }
  getAllLotteryListForSop() {
    return this.httpClient.get<SopFormResponse>(
      `${ApiUrls.allLotteryListForSop}`
    );
  }

  //Tenement Exchange
  fetchTenementList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<TenementExchangeModel>>(
      ApiUrls.tenementList + reqParams
    );
  }

  fetchTenementDetailView(applicationId: number) {
    return this.httpClient.get<TenementExchangeModel>(
      ApiUrls.viewTenementDetail.replace(
        "{applicationId}",
        applicationId.toString()
      )
    );
  }

  fetchOtp(
    otpGenerate: TenementExchangeOtpModel,
    fromApplicationNo: string,
    toApplicationNo: string,
    vacantTenementId: string,
    exchangeType: string
  ): Observable<object> {
    return this.httpClient.post<TenementExchangeOtpModel>(
      ApiUrls.fetchOtp
        .replace("{fromApplicationNo}", fromApplicationNo.toString())
        .replace(
          "{toApplicationNo}",
          toApplicationNo ? toApplicationNo.toString() : null
        )
        .replace("{vacantTenementId}", vacantTenementId.toString())
        .replace("{exchangeType}", exchangeType.toString()),
      otpGenerate
    );
  }

  resendFetchOtp(
    otpGenerate: TenementExchangeOtpModel,
    fromApplicationNo: string,
    toApplicationNo: string,
    vacantTenementId: string,
    exchangeType: string
  ): Observable<object> {
    return this.httpClient.post<TenementExchangeOtpModel>(
      ApiUrls.resendFetchOtp
        .replace("{fromApplicationNo}", fromApplicationNo.toString())
        .replace(
          "{toApplicationNo}",
          toApplicationNo ? toApplicationNo.toString() : null
        )
        .replace("{vacantTenementId}", vacantTenementId.toString())
        .replace("{exchangeType}", exchangeType.toString()),
      otpGenerate
    );
  }

  verifyOtp(
    otpVerificationRequest: TenementExchangeOtpModel,
    fromApplicationNo: string,
    toApplicationNo: string
  ): Observable<object> {
    const toApplicationNoString = toApplicationNo
      ? toApplicationNo.toString()
      : null;

    return this.httpClient.post<TenementExchangeOtpModel>(
      ApiUrls.otpVerificationForExchangeTenement
        .replace("{fromApplicationNo}", fromApplicationNo.toString())
        .replace("{toApplicationNo}", toApplicationNoString),
      otpVerificationRequest
    );
  }

  fetchNotAllowedTenement(
    page: number,
    size: number,
    exchangeType: string,
    schemeId: number,
    applicationId: number,
    lotteryId: number,
    incomeGroupId: number,
    annualFamilyIncome: number
  ) {
    let reqParams = `?page=${page}&size=${size}&exchangeType=${exchangeType}&schemeId=${schemeId}&applicationId=${applicationId}&lotteryId=${lotteryId}&incomeGroupId=${incomeGroupId}&annualFamilyIncome=${annualFamilyIncome}`;
    return this.httpClient.get<Page<TenementExchangeModel>>(
      ApiUrls.notAllowedTenement + reqParams
    );
  }

  saveExchangedTenement(tenement: TenementExchangeRequestModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.saveExchangedTenement}`,
      tenement
    );
  }

  //Upload Tenement Master
  downloadTemplate(type: string) {
    return this.httpClient.get<{
      status: string;
      errorMessage: string;
      data: string | ArrayBuffer;
    }>(ApiUrls.downloadTemplate.replace("{type}", type.toString()));
  }

  getLotteriesForBoard(boardId: number) {
    return this.httpClient.get<UploadTenementMasterModel>(
      ApiUrls.getLotteriesForBoard.replace("{boardId}", boardId.toString())
    );
  }

  saveMasterDetails(data: {
    boardId: number;
    lotteryEventId: number;
    base64Data: string | ArrayBuffer;
    fileName: string;
  }) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.saveMasterDetails,
      data
    );
  }

  fetchtenementMasterList(page: number, size: number, filterText?: string) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    return this.httpClient.get<Page<UploadTenementMasterListModel>>(
      ApiUrls.fetchtenementMasterList + reqParams
    );
  }

  fetchEditDetails(key: number) {
    return this.httpClient.get<UploadTenementMasterModel>(
      ApiUrls.fetchEditDetails.replace("{key}", key.toString())
    );
  }

  updateMasterDetails(data: UploadTenementMasterListModel) {
    return this.httpClient.post<{ status: string; errorMessage: string }>(
      ApiUrls.updateMasterDetails,
      data
    );
  }

  deleteMasterEntry(key: number, isActive: string) {
    return this.httpClient.patch<{ status: string; errorMessage: string }>(
      ApiUrls.deleteMasterEntry.replace("{key}", key.toString()),
      {
        isActive,
      }
    );
  }

  async successToast(msg) {
    await this._snackBar.open(msg, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  getSchemeApplicationFilterList(
    lottery: number,
    scheme: any,
    page: number,
    size: number,
    filterText?: string
  ) {
    let reqParams =
      `?page=${page}&size=${size}` +
      (filterText ? `&filterText=${filterText}` : "");
    console.log("Api Called");

    return this.httpClient.get<Page<SurrReqVerificationResponse>>(
      ApiUrls.getSchemeApplicationFilterList
        .replace(`{lotteryId}`, lottery.toString())
        .replace(`{schemeId}`, scheme) + reqParams
    );
  }

  addcorigendumForLottery(
    lottery: number,
    corrigendumName: string,
    corrigendumFileName: string
  ) {
    console.log("Lotteryid content from service", lottery);

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.addCorrigendumForLottery}/${lottery}`,
      {
        // key: key,
        // registrationId: registrationId,
        lottery: lottery,
        corrigendumName: corrigendumName,
        corrigendumFileName: corrigendumFileName,
      }
    );
  }

  addCorrigendumForLotteryAndScheme(
    lottery: number,
    scheme: number,
    corrigendumName: string,
    corrigendumFileName: string
  ) {
    console.log("Lotteryid content from service", lottery);
    console.log("Schemeid content from service", scheme);

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.addCorrigendumForLotteryAndScheme}/${lottery}/${scheme}`,
      {
        lottery: lottery,
        scheme: scheme,
        corrigendumName: corrigendumName,
        corrigendumFileName: corrigendumFileName,
      }
    );
  }

  addCorrigendumForApplication(
    lottery: number,
    scheme: number,
    applicationNo: string,
    corrigendumName: string,
    corrigendumFileName: string
  ) {
    console.log("Lotteryid content from service", lottery);
    console.log("Schemeid content from service", scheme);
    console.log("applicationNo content from service", applicationNo);

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.addCorrigendumForApplication}/${applicationNo}`,
      {
        lottery: lottery,
        scheme: scheme,
        applicationNo: applicationNo,
        corrigendumName: corrigendumName,
        corrigendumFileName: corrigendumFileName,
      }
    );
  }

  addCorrigendumForSelectedApplication(
    lottery: number,
    scheme: number,
    selectedApplicationNumbers: string[],
    corrigendumName: string,
    corrigendumFileName: string
  ) {
    console.log("Lotteryid content from service", lottery);
    console.log("Schemeid content from service", scheme);
    console.log(
      "applicationNo content from service",
      selectedApplicationNumbers
    );
    const applicationNumbersString = selectedApplicationNumbers.join(",");

    return this.httpClient.post<{ status: string; errorMessage: string }>(
      `${ApiUrls.addCorrigendumForSelectedApplication}/${applicationNumbersString}`,
      {
        lottery: lottery,
        scheme: scheme,
        //  applicationNumbers: selectedApplicationNumbers,
        corrigendumName: corrigendumName,
        corrigendumFileName: corrigendumFileName,
      }
    );
  }
}
